import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RestService } from '../services/rest.service';
import { Router } from '@angular/router';
import 'rxjs/add/operator/filter';
import { toJSDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar';

@Component({
  selector: 'app-signup',
  templateUrl: './continue.component.html',
  styleUrls: ['./continue.component.scss']
})
export class ContinueComponent implements OnInit {

  token: string;
  id: string;
  package: string;
  fullname: string;
  email: string;
  password: string;

  fullname_valid = true;
  email_valid = true;
  password_valid = true;
  token_valid = false;
  token_invalid = false;
  register_valid = true;
  reason_code: string;

  constructor(private route: ActivatedRoute, private restService: RestService, private router: Router) {
    this.reason_code = "100";
  }

  ngOnInit() {
    this.route.queryParamMap
      .subscribe((params) => {
        this.token = params.get('token');
        this.process_continue_data();
      });
  }

  process_continue_data() {
    const token = { token: this.token };
    this.restService.process_continue_data(token).subscribe(data => {
      if (data.success) {
        this.token_valid = true;
        let record = data.record ? data.record : {};
        this.id = record.id ? record.id : null;
        this.package = record.package ? record.package : null;
        this.fullname = record.fullname ? record.fullname : '';
        this.email = record.email ? record.email : '';
      } else {
        this.token_invalid = true;
      }
    });
  }

  process_continue() {
    this.fullname_valid = (this.fullname != null && this.fullname != '');
    this.email_valid = (this.email != null && this.email != '');
    this.password_valid = (this.password != null && this.password != '');

    if (this.fullname_valid && this.email_valid && this.password_valid) {
      const data = {
        id: this.id,
        package: this.package,
        fullname: this.fullname,
        email: this.email,
        password: this.password,
        token: this.token
      };
      this.restService.process_continue(data).subscribe(data => {
        if (data.success) {
          this.restService.setToken(data.token);
          const token = this.restService.getToken();
          if (token) this.router.navigateByUrl('/');
          else this.router.navigateByUrl('/signin');
        } else {
          this.register_valid = false;
          this.reason_code = data.reason_code;
        }
      });
    }
  }

}
